import React from 'react';
import { useLocation } from 'react-router-dom';
import ExperimentManager from './ExperimentManager';
import ExperimentResults from './ExperimentResults';
import CreateExperiment from './CreateExperiment';

const ExperimentSection = () => {
  const location = useLocation();

  const renderContent = () => {
    const path = location.pathname;

    if (path.includes('/experiments/results')) {
      return <ExperimentResults />;
    } else if (path.includes('/experiments/create')) {
      return <CreateExperiment />;
    } else {
      return <ExperimentManager />;
    }
  };

  return renderContent();
};

export default ExperimentSection;
